import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ClientServices } from '../../@theme/services/clients.service';
/* import { NbButtonModule } from '@nebular/theme'; */
@Component({
    selector: 'gd-pdfsavior',
    template: `
    <div id="print-content" style="padding:10px;">
      <h2 style="font-size:15px;">Account Form Receipt</h2>
      <table width="100%">
        <tr>
          <td style="font-size:12px;">Rep Name: {{ RepNamInfo.repName }}</td>
        </tr>
        <tr>
          <td style="font-size:12px;">
            {{ RepNamInfo.clientName }}
          </td>
        </tr>
        <tr>
          <td style="font-size:12px;">Account: {{ RepNamInfo.accountName }}</td>
        </tr>
        <td style="font-size:12px;">
          Has the submitted Account Form been reviewed and approved?&nbsp;Yes
        </td>
        <tr>
          <td style="font-size:12px;">Comments:</td>
        </tr>
        <tr>
          <td style="font-size:12px;">
            <p *ngIf="showcomment">No comments were entered.</p>
            <div *ngFor="let cx of Comments">
              {{ cx.comments }}<br />
              ---------------------------------
            </div>
            <hr />
          </td>
        </tr>
        <tr>
          <td style="font-size:12px;">
            Approved by:&nbsp; {{ approvalBy }}
          </td>
        </tr>
        <tr>
          <td style="font-size:12px;">
            Approval date:&nbsp;{{ approvalDate | date : 'M/d/yy, h:mm a' }}
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>
            <!-- <input type="button" value="Print" onclick="window.print();" />&nbsp;<input type="button" value="Close" onclick="window.close();" /> -->
          </td>
        </tr>
      </table>
    </div>
    <hr />
    <p style="float:right; margin-right:10px;">
      <button
        nbButton="prstatusimary"
        size="tiny"
        onClick="printDiv('print-content')"
      >
        Print
      </button>
    </p>
    <!--  <hr><p style="float:right; margin-right:10px;"><button nbButton ="prstatusimary" size="tiny" onClick="printDiv('print-content')">Print</button></p> -->
  `,
    encapsulation: ViewEncapsulation.None,
    styles: [
        `
      kendo-pdf-export {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
        font-size: 12px;
        background-color: #fff;
        color: #000;
      }
    `,
    ],
    imports: [
        NgIf,
        NgFor,
/*         NbButtonModule, */
        DatePipe,
    ],
    standalone: true
})
export class PdfSaveComponent {
  @Input() RepNamInfo: any
  private getBlotId: number
  public showcomment = false
  @Input() set blotterId(val: number) {
    this.getBlotId = val
    this.loadBlotterCommentData()
  }
  public Comments: any[] = []
  public approvalBy: string
  public approvalDate: Date
  constructor(private cliservice: ClientServices) {}

  loadBlotterCommentData() {
    const param = { blotId: this.getBlotId }
    this.cliservice
      .getAccountformReviewslist(param)
      .subscribe((response: any[]) => {
        console.log(JSON.stringify(response))
        const review: any = response
        this.approvalBy = review?.modifiedBy
        this.approvalDate = review?.modifiedDate

        const getcomments = (response ?? []).map((x) => x.comments)
        if (getcomments.toString() != '') {
          this.Comments = response
          this.showcomment = false
          return
        }
        this.showcomment = true
        return
      })
  }
}
